import React from 'react'
// import Loading from '@components/loading/normal'
import noRoleImg from '@assets/noRole.png'

export const UserLoading = ({ txt }) => {
  return (
    <div className="mt-40 text-center">
      {/* <Loading /> */}
      <p>{txt || '页面加载中....'}</p>
    </div>
  )
}

export const UnLogin = ({ txt }) => {
  return (
    <div className="w-10/12 m-auto mt-40 text-center">
      <img src={noRoleImg} alt="暂无权限" />
      <p className="text-base mt-6">
        {txt || '您暂无权限查看，请联系管理员加入'}
      </p>
    </div>
  )
}

export const ErrorPage = ({ txt, error }) => {
  return (
    <div className="w-10/12 m-auto mt-40 text-center">
      <a
        onClick={() => {
          window.location.href = window.location.pathname + '?debug=1'
        }}
      >
        <img src={noRoleImg} alt="暂无权限" />
      </a>
      <p className="text-base mt-6">
        {txt || '您暂无权限查看，请联系管理员加入'}
      </p>
      <p>{error}</p>
      <a
        onClick={() => {
          window.location.reload()
        }}
        className=" inline-block p-4 border-solid  border-2 mt-22"
      >
        刷新
      </a>
    </div>
  )
}
